import React from 'react'

import { IApplicantProgram } from '../../../../interfaces/student';

import { Icons } from '../../../../data/Assets';

import { SVGIcon } from '../../../wrappers/SVGIcon';

interface IOtherProgramCardProps {
    program: IApplicantProgram;
}
const OtherProgramCard = (props: IOtherProgramCardProps) => {
    const { program } = props;

    return (
        <div className='immersion__recommendation_card'>
            <div className='immersion__recommendation_card__content'>
                <div className='immersion__recommendation_card__header'>
                    <h5 className='immersion__recommendation_card__header_title'>
                        {program.name}
                    </h5>
                </div>
                <div className='immersion__recommendation_card__body'>
                    <h6 className='immersion__recommendation_card__body__description'>
                        {program.description}
                    </h6>
                </div>
            </div>
            <div className='immersion__recommendation_card__favorite_icon_container'>
                <SVGIcon src={program.favorite ? Icons.HeartFill : Icons.Heart} color='primary' />
            </div>
        </div>
    )
}

export default OtherProgramCard;